'use client'

import type { ReactNode } from 'react'

import { useEffect } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer/models/event'

export function useErrorMessage(
  errorMessageElements: string[],
  children: ReactNode
) {
  const { publish } = useEventBusContext()

  useEffect(() => {
    if (!errorMessageElements.length && !children) {
      return
    }
    const errorTitle = errorMessageElements.length
      ? errorMessageElements.join(', ')
      : typeof children === 'string'
        ? children
        : ''
    if (!errorTitle) {
      return
    }
    publish(EventType.ERROR_MESSAGE, {
      errorType: 'validation',
      errorTitle,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessageElements.join(','), children])
}
